import React, { useEffect, useState } from "react";
import * as Yup from "yup";

import { Typography, Box, TextField, Container } from "@mui/material";
import { PrimaryButton, SecondaryButton } from "../../../../common/Buttons";
import { Form, Formik } from "formik";
import {
  getHealthcareProxy,
  postHealthcareProxy,
} from "../../../../services/documentServices";
import { toast } from "react-hot-toast";
import InputField from "../../../../common/InputField";
import { getUserIdFromLocalStorage } from "../../../../utils/Utilities";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Circles } from "react-loader-spinner";

function Signature(props) {
  const { id } = useParams();
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  const [initialValues, setInitialValues] = useState({
    place: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  async function fetchData() {
    setIsLoading(true);
    try {
      const result = await getHealthcareProxy(id);
      if (result?.success && result?.payLoad) {
        setData(result.payLoad);
        setInitialValues({
          place: result.payLoad.place,
        });
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  }
  useEffect(() => {
    fetchData();
  }, []);

  const handleSubmit = async (values) => {
    props.setButtonDisabled(true);
    const { place } = values;
    const payload = {
      ...data,
      place,
    };
    const result = await postHealthcareProxy(payload, id);
    if (result?.success) {
      props.next();
    }
    props.setButtonDisabled(false);
  };

  return (
    <>
      {isLoading ? (
        <Box component="div" className="loader-container">
          <Circles color="#dfc8db" height={80} width={80} />
        </Box>
      ) : (
        <Container maxWidth="xs">
          <Formik
            initialValues={initialValues}
            enableReinitialize
            onSubmit={(values) => {
              handleSubmit(values);
            }}
          >
            {(formik) => {
              return (
                <Form id="form_submit" onSubmit={formik.handleSubmit}>
                  <Box sx={{ mt: 5, textAlign: "center" }}>
                    <Typography
                      sx={{ mt: 5 }}
                      variant="p"
                      paragraph
                      align="left"
                      color="color.black"
                    >
                      {t("input-20")}
                    </Typography>

                    <InputField
                      fullWidth
                      variant="standard"
                      placeholder="Karlsruhe, 15th March 2022"
                      name="place"
                      type="date"
                    />

                    <Typography
                      sx={{ mt: 5 }}
                      variant="p"
                      paragraph
                      align="left"
                      color="color.black"
                    >
                      {t("doc-tab-3")}
                    </Typography>

                    <Typography
                      sx={{ mt: 5 }}
                      variant="p"
                      paragraph
                      align="center"
                      color="color.black"
                      fontStyle="italic"
                    >
                      {t("please-sign")}
                    </Typography>
                    <TextField
                      fullWidth
                      variant="standard"
                      name="sign"
                      type="text"
                      sx={{
                        pointerEvents: "none",
                      }}
                    />
                  </Box>
                </Form>
              );
            }}
          </Formik>
        </Container>
      )}
    </>
  );
}

export default Signature;
